
export class EntPopulationFilter {
  animalTypeIds: number | null = null;
  districtId: number | null = null;
  areaId: number | null = null;
  countFrom: number | null = null;
  countTo: number | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  deleted: boolean = false;
  page: number = 1;
  size: number = 30;
}
